module.exports = __webpack_public_path__ + "static/man-with-a-van-11541f6fab0511a16a44aa2b1437ed92.png";